import type {
    FC
} from "react";
import {
    Pressable,
    View
} from "react-native";
import type ICodeViewerFoldButtonProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    ChevronRight as ChevronRightIcon,
    ChevronDown as ChevronDownIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";
import StateLayer from "../../../stateLayer";

const CodeViewerFoldButton: FC<ICodeViewerFoldButtonProps> = ({
    accessibilityLabel,
    customTheme,
    isCollapsed,
    onPress,
    size
}) => {
    const {
        shapeConfigs,
        touchTargets,
        typography,
        iconSizes,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState();

    const {
        container: containerDynamicStyle,
        surface: surfaceDynamicStyle
    } = useStyles({
        isFocusVisible,
        shapeConfigs,
        touchTargets,
        pointerType,
        typography,
        iconSizes,
        radiuses,
        borders,
        colors,
        size
    });

    return <Pressable
        {...interactionHandlers}
        accessibilityLabel={accessibilityLabel}
        aria-expanded={!isCollapsed}
        style={[
            stylesheet.foldButton,
            containerDynamicStyle
        ]}
        onPress={onPress}
        role="button"
    >
        <View
            style={[
                stylesheet.foldSurface,
                surfaceDynamicStyle
            ]}
        >
            <StateLayer
                borderRadius={radiuses.xs}
                customTheme={customTheme}
                overlayColor="default"
                isHovered={isHovered}
                isPressed={isPressed}
            />
            <AnimatedIcon
                isTransitioned={!isCollapsed}
                fromIcon={ChevronRightIcon}
                customTheme={customTheme}
                toIcon={ChevronDownIcon}
                iconTransition="morph"
                size={iconSizes.small}
                isMirrored={false}
                color="mid"
            />
        </View>
    </Pressable>;
};

export default CodeViewerFoldButton;
